import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface RequirePermissionProps {
  children: React.ReactNode;
  permission: string;
  fallback?: React.ReactNode;
}

export default function RequirePermission({ 
  children, 
  permission, 
  fallback = <Navigate to="/tasks" replace /> 
}: RequirePermissionProps) {
  const { hasPermission, loading } = useUserPermissions();

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  if (!hasPermission(permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}

































